define('commons/save-search-widget',[ 'jquery', 'commons/flat-tree', 'commons/flat-tree-popup', 'commons/message-manager' ], function($, FlatTree, FlatTreePopup, messages) {

    var SaveSearchWidget = function(triggerSelector, beanName, onSearchSelected) {
        var here = this;
        
        this.itemInfo = null;
        this.onSearchSelected = onSearchSelected;
        this.$searchNameInput = $('<input id="search-name" placeholder="Search name" name="search-name" type="text"/>');

        this.popup = new FlatTreePopup(triggerSelector, {
            title : 'Save the current search',
            close : here._showSearchListPanel
        }, {
            reset : true,
            createTree : function(container) {
                return new FlatTree(container, {
                    autoLoad : false,
                    nbPanels : 1,
                    loadItemUrl : '/userPrefs/json/searches/' + beanName,
                    createItem : function(item) {
                        item.isLeaf = true;
                        return {
                            id : item.id,
                            text : item.name,
                            link : true,
                            events : {
                                'click' : $.proxy(here._openSearchNamePanel, here)
                            }
                        };
                    }
                });
            }
        });

        this._createPanels();
    };

    SaveSearchWidget.prototype._closeAndLoadSearch = function(event) {
        this.popup.dialogSelector.dialog('close');
        this.onSearchSelected( $.extend( this.itemInfo, { text : this.$searchNameInput.val() } ) );
    };

    SaveSearchWidget.prototype._showSearchListPanel = function() {
        $('.search-name-panel').removeClass('opened');
        $('.save-panel').fadeIn('fast');
    };

    SaveSearchWidget.prototype._openSearchNamePanel = function(event) {
        $('.save-panel').fadeOut('fast');
        $('.search-name-panel').addClass('opened');
        this.itemInfo = $(event.target).data('itemInfo');

        if (this.itemInfo) {
            this.$searchNameInput.val(this.itemInfo.text).select();
        } else {
            this.$searchNameInput.val('');
        }

        setTimeout($.proxy(function() {
            this.$searchNameInput.focus();
        }, this), 600);
    };

    SaveSearchWidget.prototype._createPanels = function() {
        var $content = this.popup.dialogSelector.dialog('widget').find('.ui-dialog-content');
        var searchesList = $content.find('.popup-selector');
        searchesList.css('position', 'relative');
        var $topPanel = $('<div class="save-panel"></div>');

        $content.css('overflow-x', 'hidden');
        $content.append($topPanel);

        // Create search button + text
        $topPanel.append('<button id="create-search-btn" class="sigfox-action-btn" type="button">Create a new search</button>');
        $topPanel.append('<div class="save-search-separator"></div>');
        $topPanel.append('<p class="save-search-description-text">Or override an existing one</p>');
        $topPanel.append(searchesList);

        // Hidden panel to fill the search name
        var $rightPanel = $('<div class="search-name-panel"><div class="filler"></div></div>');
        // description
        $rightPanel.append('<div class="save-search-description-text save-as-text">Please enter the search name.</br> If you are overriding an existing one, you can change its name even so.</div>');
        // Search text field div
        $rightPanel.append($('<div class="search-name-wrapper"></div>').append(this.$searchNameInput));
        // buttons bar
        $rightPanel.append($('<div class="search-name-buttons">'
                                + '<button id="back-btn" class="sigfox-action-btn" type="button">Back</button>'
                                + '<button id="save-btn" class="sigfox-action-btn" type="submit">Save</button>' 
                          + '</div>'));
        $content.append($rightPanel);

        this._bindButtons();
    };

    SaveSearchWidget.prototype._bindButtons = function() {
        // Create search btn
        $('#create-search-btn').on('click', $.proxy(this._openSearchNamePanel, this));

        // Back btn
        $('#back-btn').on('click', $.proxy(this._showSearchListPanel, this));

        // Save btn & enter pressed in the text field => submit
        var save = $.proxy(function() {
            if( !this.$searchNameInput.val()){
                messages.error('Search name is mandatory');
            } else {
                this._closeAndLoadSearch();
            }
        }, this);
        $('#save-btn').on('click', save);
        this.$searchNameInput.on('keypress', function(e){
            if(e.which == 13){ // enter code
                save();
            }
        });
    };

    return SaveSearchWidget;
});
